var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-popover",
    {
      ref: "popover",
      attrs: {
        placement: "bottom",
        "boundaries-element": "viewport",
        delay: { hide: 100 },
        trigger: "click",
      },
      scopedSlots: _vm._u([
        {
          key: "popover",
          fn: function () {
            return [
              _c(
                "b-col",
                [
                  _c(
                    "b-row",
                    { staticClass: "filter-title py-2 column-divider-bottom" },
                    [
                      _c("b", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("referrers.actions.filterReferrersBy")
                            ) +
                            "... "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticStyle: { "flex-grow": "0" } },
                        [
                          _c(
                            "b-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                "b-col",
                                { staticClass: "py-2 filter-title" },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$tc("global.doorr.referralType")
                                      ) + ":"
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-row", { attrs: { "no-gutters": "" } }, [
                            _c(
                              "fieldset",
                              { attrs: { id: "board-filters" } },
                              [
                                _c(
                                  "b-row",
                                  { attrs: { cols: "1", "no-gutters": "" } },
                                  _vm._l(
                                    _vm.referrerTypeOptions,
                                    function (type) {
                                      return _c(
                                        "b-col",
                                        {
                                          key: type.id,
                                          staticClass:
                                            "pretty p-default p-round p-smooth mr-0 mb-3",
                                        },
                                        [
                                          _c("input", {
                                            staticClass: "form-check-input",
                                            attrs: {
                                              id: type.text,
                                              type: "radio",
                                              name: "board-filters",
                                              value: "none",
                                            },
                                            domProps: {
                                              checked:
                                                _vm.selectedTags.type ===
                                                type.id,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.handleChange(type.id)
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "state p-primary" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "clickable text-light-gray",
                                                  attrs: { for: type.text },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(type.text) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "tooltip-target" }, [
        _c(
          "div",
          { staticClass: "ml-0 mx-lg-3 text-gray capitalize clickable p-2" },
          [
            _c(
              "span",
              [
                _c(
                  "b-row",
                  { attrs: { "align-h": "center", "no-gutters": "" } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$tc("global.words.filter", 1)) +
                        "\n          "
                    ),
                    _c("icon", {
                      attrs: { name: "sort-desc", "icon-class": "ml-1" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }